module.exports = __webpack_public_path__ + "static/media/p5.0d6485c6.png";